export default __webpack_public_path__ + "static/media/Pasargad_Bank.65f45e09.png";